<template>
  <custom-tab-item :active="active" title="Detalle de Servicios">
    <article>
      <section v-if="selectedList.length > 0" class="container-fluid mb-4">
        <icon-view
          gradient
          icon="fa fa-file-invoice-dollar"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Servicio(s) Seleccionado(s)"
        />

        <row
          v-for="item in selectedList"
          :key="`${item.visitSummaryId}-${item.serviceId}`"
          :action="{
            name: 'Remover',
            icon: 'fa-minus-circle',
            variant: 'outline-danger',
            actionClick: () => {
              $emit('update', item, true);
            },
          }"
          :disable="disable"
          :item="item"
        />
      </section>
      <section v-if="!disable" class="container-fluid mb-4">
        <icon-view
          gradient
          icon="fa fa-file-invoice-dollar"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Servicios disponibles"
        />
        <div v-if="availableList.length === 0" class="empty-content">
          <label for="">No disponibles</label>
        </div>
        <row
          v-for="item in availableList"
          :key="`${item.visitSummaryId}-${item.serviceId}`"
          :action="{
            name: 'Facturar',
            icon: 'fa-check',
            variant: 'outline-success',
            actionClick: () => {
              $emit('update', item, false);
            },
          }"
          :disable="disable"
          :item="item"
        />
      </section>
    </article>
    <section
      v-if="disable && selectedList.length === 0"
      class="container-fluid mb-4"
    >
      <div class="empty-content text-center">
        <label>
          No cuenta con servicios adicionales para facturar en este periodo.
        </label>
      </div>
    </section>
  </custom-tab-item>
</template>

<script>
import { CustomTabItem } from 'custom-tabs';
import IconView from '../IconView';
import Row from './TabServiceDetailRow.vue';
export default {
  components: {
    CustomTabItem,
    IconView,
    Row,
  },
  props: {
    detail: {
      type: Object,
      require: true,
      default: () => ({
        summaryId: 0,
        services: [
          {
            summaryId: 1,
            serviceId: 126,
            serviceName: 'Matematica',
            serviceCost: 20,
            isSelected: false,
          },
        ],
      }),
    },
    active: {
      type: Boolean,
      require: false,
      default: false,
    },
    disable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedList() {
      const list = this?.detail?.services ?? [];
      return list.filter((x) => x.isSelected);
    },
    availableList() {
      const list = this?.detail?.services ?? [];
      return list.filter((x) => !x.isSelected);
    },
  },
  mounted() {
    this.$emit('getServiceDetail');
  },
};
</script>

<style>
.empty-content {
  background: #f7f7f7;
  border-radius: 7px;
  margin: 10px 0 0 0;
  padding: 15px 0 6px 26px;
}
</style>
